export default {
    listagem: {
        titulo_pagina: 'Lista de Protocolos',
        novo: 'Crear Nuevo Protocolo',
        table: {
            empty: 'No se encontró ningún protocolo',
            nome: 'Nombre',
            classe: 'Clase',
            editar: 'Editar'
        }
    },
    form: {
        titulo_pagina: {
            criar: 'Crear Nuevo Protocolo',
            editar: 'Editar Protocolo'
        },
        fields: {
            nome: {
                label: 'Nombre',
                description: 'Nombre del Protocolo'
            },
            classe: {
                label: 'Clase',
                description: 'Clase que ejecuta el Protocolo'
            },
            status: {
                label: 'Estado',
                description: 'Protocolo estado activo o inactivo'
            },
            has_protocol_settings: {
                label: 'Configuración de protocolo',
                description: 'Configuración para protocolo Genérico.'
            },
            protocol_settings: {
                label: 'Nombre de configuración',
                description: 'Configuración para automatizar la extracción de solicitudes y resultados del protocolo.'
            },
            botao_salvar : 'Guardar Protocolo'
        },
        create: {
            success: '¡Protocolo creado con éxito!',
            error: '¡Error al crear el protocolo!'
        },
        update: {
            success: '¡Protocolo editado con éxito!',
            error: '¡Error al editar el Protocolo!'
        }
    }
}
